import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"
import { formatPhoneNumberIntl } from "react-phone-number-input"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatCurrency(value: number): string {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(value)
}

export function formatPhone(phone: string | null | undefined): string {
  if (!phone) return '-'
  // Stored numbers are E.164 digits without the plus (5511990000024);
  // the formatter only recognises them with it.
  const candidate = /^\d{10,15}$/.test(phone) ? `+${phone}` : phone
  return formatPhoneNumberIntl(candidate) || phone
}
